import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}api/` || 'http:localhost:3001/api/',
  headers: {
    'Content-Type': 'application/json',
    'platform': 'admin'
  },
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem('data'))?.auth_token || '';
    if (token) {
      config.headers['Authorization'] = token;
      config.platform = 'admin'
    }
    return config;
  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
